// CETRA-38: keep legacy effect timing while clearing release ESLint warnings.
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box, CircularProgress, CssBaseline, ThemeProvider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { AuthState } from '../../../stores/auth-store';
import StoreContext from './store-context';
import ScrollToTop from '../global/ScrollToTop';

const AppLoadingScreen = () => (
    <Box
        sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#F0F0FC',
        }}
    >
        <CircularProgress />
    </Box>
);

// We are observing the authState from authStore mobx store
export const InnerApp = observer(
    ({ AuthenticatedComponent, UnauthenticatedComponent, theme, globalComponents, globalAuthenticatedComponents }) => {
        const contextValue = useContext(StoreContext);

        console.log('Do we have contextValue?', !!contextValue);
        if (!contextValue) {
            console.log('No contextValue');
            return null;
        }

        const authStore = contextValue.authStore;

        console.log('Do we have authStore?', !!authStore);
        if (authStore) {
            console.log('Current authState:', authStore.authState);
        }

        const isInitializing = !authStore || authStore.authState === AuthState.UNINITIALIZED;
        const appToRender = isInitializing ? (
            <AppLoadingScreen />
        ) : authStore.isAuthenticated() ? (
            <AuthenticatedComponent />
        ) : (
            <UnauthenticatedComponent />
        );

        const globalAuthenticatedComponentsToRender =
            authStore && authStore.isAuthenticated() ? globalAuthenticatedComponents : null;

        return (
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Router>
                    <ScrollToTop />
                    {globalComponents}
                    {globalAuthenticatedComponentsToRender}
                    {appToRender}
                </Router>
            </ThemeProvider>
        );
    },
);

function AuthenticatedAppWithStore({
    AuthenticatedComponent,
    UnauthenticatedComponent,
    createAppStateStore,
    theme,
    globalComponents,
    globalAuthenticatedComponents,
}) {
    const [appStateStore, setAppStateStore] = useState(null);

    useEffect(() => {
        // console.log('AuthenticatedApp::useEffect');
        setAppStateStore(createAppStateStore());
    }, []);

    if (!appStateStore) {
        return (
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AppLoadingScreen />
            </ThemeProvider>
        );
    }

    return (
        <StoreContext.Provider value={appStateStore}>
            <InnerApp
                AuthenticatedComponent={AuthenticatedComponent}
                UnauthenticatedComponent={UnauthenticatedComponent}
                theme={theme}
                globalComponents={globalComponents}
                globalAuthenticatedComponents={globalAuthenticatedComponents}
            />
        </StoreContext.Provider>
    );
}

export default observer(AuthenticatedAppWithStore);
